{
  "name": "netlicensing-client",
  "version": "2.0.4",
  "description": "JavaScript Wrapper for Labs64 NetLicensing RESTful API",
  "keywords": [
    "labs64",
    "netlicensing",
    "licensing",
    "licensing-as-a-service",
    "license",
    "license-management",
    "software-license",
    "client",
    "restful",
    "restful-api",
    "javascript",
    "wrapper",
    "api",
    "client"
  ],
  "license": "Apache-2.0",
  "author": "Labs64 GmbH",
  "homepage": "https://netlicensing.io",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/Labs64/NetLicensingClient-javascript.git"
  },
  "bugs": {
    "url": "https://github.com/Labs64/NetLicensingClient-javascript/issues"
  },
  "contributors": [
    {
      "name": "Ready Brown",
      "email": "ready.brown@hotmail.de",
      "url": "https://github.com/r-brown"
    },
    {
      "name": "Viacheslav Rudkovskiy",
      "email": "viachaslau.rudkovski@labs64.de",
      "url": "https://github.com/v-rudkovskiy"
    },
    {
      "name": "Andrei Yushkevich",
      "email": "yushkevich@me.com",
      "url": "https://github.com/yushkevich"
    }
  ],
  "main": "dist/index.cjs",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.cjs"
    }
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup",
    "release": "npm run lint:typecheck && npm run test && npm run build",
    "dev": "tsup --watch",
    "test": "vitest run",
    "test:dev": "vitest watch",
    "lint": "eslint --ext .js,.mjs,.ts src",
    "typecheck": "tsc --noEmit",
    "lint:typecheck": "npm run lint && npm run typecheck"
  },
  "peerDependencies": {
    "axios": "^1.9.0"
  },
  "dependencies": {},
  "devDependencies": {
    "@eslint/js": "^9.39.4",
    "@types/node": "^25.3.5",
    "@typescript-eslint/eslint-plugin": "^8.29.1",
    "@typescript-eslint/parser": "^8.29.1",
    "@vitest/eslint-plugin": "^1.1.43",
    "axios": "^1.13.6",
    "eslint": "^9.39.4",
    "eslint-plugin-import": "^2.31.0",
    "prettier": "3.8.1",
    "tsup": "^8.4.0",
    "typescript": "^5.8.3",
    "typescript-eslint": "^8.29.1",
    "vitest": "^3.2.4"
  },
  "engines": {
    "node": ">= 16.9.0",
    "npm": ">= 8.0.0"
  },
  "browserslist": [
    "> 1%",
    "last 2 versions",
    "not ie <= 10"
  ]
}
